import { render, staticRenderFns } from "./cocal-system-match-add.vue?vue&type=template&id=a9fc813a&"
import script from "./cocal-system-match-add.vue?vue&type=script&lang=js&"
export * from "./cocal-system-match-add.vue?vue&type=script&lang=js&"
import style0 from "./cocal-system-match-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports